var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSettingNotificationIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.55664 17.5C8.70293 17.7533 8.91332 17.9637 9.16668 18.11C9.42003 18.2563 9.70743 18.3333 9.99997 18.3333C10.2925 18.3333 10.5799 18.2563 10.8333 18.11C11.0866 17.9637 11.297 17.7533 11.4433 17.5",
    stroke: "#647084",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.71821 12.7717C2.60935 12.8911 2.53751 13.0394 2.51143 13.1988C2.48534 13.3582 2.50615 13.5218 2.5713 13.6696C2.63646 13.8174 2.74316 13.943 2.87843 14.0313C3.01369 14.1196 3.1717 14.1666 3.33321 14.1667H16.6665C16.828 14.1668 16.9861 14.1199 17.1214 14.0318C17.2568 13.9437 17.3636 13.8182 17.429 13.6705C17.4943 13.5228 17.5153 13.3593 17.4894 13.1999C17.4635 13.0405 17.3919 12.892 17.2832 12.7726C16.1749 11.6301 14.9999 10.4159 14.9999 6.66675C14.9999 5.34067 14.4731 4.0689 13.5354 3.13121C12.5977 2.19353 11.326 1.66675 9.99988 1.66675C8.6738 1.66675 7.40203 2.19353 6.46435 3.13121C5.52666 4.0689 4.99988 5.34067 4.99988 6.66675C4.99988 10.4159 3.82405 11.6301 2.71821 12.7717Z",
    stroke: "#647084",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingNotificationIcon);
export default __webpack_public_path__ + "static/media/SettingNotificationIcon.3a2df6fb50657f6757c7492d62f3d17c.svg";
export { ForwardRef as ReactComponent };